import { Box } from '@mui/material';
import { type FC, type PropsWithChildren } from 'react';

import { useGetEnvConfig } from '@/api/useGetEnvConfig.util.ts';
import FullPageSpinner from '@/components/ui/fullPageSpinner/FullPageSpinner.tsx';
import MaintenanceView from '@/views/maintenance/Maintenance.view.tsx';

export const ConfigInitializeController: FC<PropsWithChildren> = ({ children }) => {
  const { data, isPending } = useGetEnvConfig();

  if (isPending) {
    return <FullPageSpinner />;
  }

  if (data?.maintenance === 'true') {
    return (
      <Box sx={{ display: 'flex' }}>
        <Box
          sx={{
            alignItems: 'center',
            backgroundColor: 'primary.bg',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            minHeight: '100dvh',
            width: '100%',
          }}
        >
          {' '}
          <MaintenanceView />
        </Box>
      </Box>
    );
  }

  return children;
};
